<template>
  <section v-if="feedbackStatus">
    <div class="pdl-16 pdr-16" v-if="isCommon()">
      <div class="mdc-card mdc-elevation--z3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="t-body2 mgl-16 mgr-16">
            {{ $t("1393") }}
            <!-- Commentary -->
          </div>
          <div>
            <button
              class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded degree-card-more-button t-color-bodyGrayA"
              @click="toggleCommentaryViewStatus()"
            >
              {{ commentaryViewStatus ? "expand_less" : "expand_more" }}
            </button>
          </div>
        </div>
        <div class="pda-default t-color-bodyGrayA t-body3" v-show="commentaryViewStatus">
          <vue-mathjax :formula="commonFeedback"></vue-mathjax>
        </div>
      </div>
    </div>

    <div class="mgt-16 pdl-16 pdr-16" v-if="stateQuestionButton()">
      <button
        class="mdc-button mdc-button--raised btn-red"
        @click="moveQuestion()"
      >
        {{ $t("1394") }}
        <!-- question -->
      </button>

      <button class="mdc-button mdc-button--raised btn-white mgr-8 mgl-8" @click="moveIssue()">
        {{ $t("1395") }}
        <!-- Declaration -->
      </button>
    </div>

    <!-- <div class="top"></div> -->
    <div class="mgt-16  pda-default bg-bottom-shape">
      <div v-if="isCorrect()">
        <div class="t-body2">
          {{ $t("1398") }}
          <!-- You got the right answer! -->
        </div>
        <div class="t-body3 t-color-bodyGrayA mgt-16">
          <vue-mathjax
            :formula="strippedContent(correctFeedback)"
          ></vue-mathjax>
        </div>
      </div>
      <div v-if="isIncorrect()">
        <div class="t-body2">
          {{ $t("1402") }}
          <!-- It is wrong answer -->
        </div>
        <div class="t-body3 t-color-bodyGrayA mgt-16">
          <vue-mathjax
            :formula="strippedContent(incorrectFeedback)"
          ></vue-mathjax>
        </div>
      </div>

            <!-- Commentary video -->

      <div v-if="isVideo()">
        <hr class="divider mgt-16" />
        <div>
          <div class="t-body2 mgt-16">
            {{ $t("1399") }}
          </div>

          <div>
            <video width="320" height="240" controls class="w-full">
              <source :src="videoFeedback.mp4" type="video/mp4">
            </video>
            <!-- <video :src="videoFeedback.mp4" class="w-full"></video> -->
          </div>
        </div>
      </div>

      <div class="mgt-16 mgb-34 " v-if="!stateQuestionButton()">
        <button
          class="mdc-button mdc-button--raised btn-red"
          @click="moveQuestion()"
        >
          {{ $t("1394") }}
          <!-- question -->
        </button>

        <button class="mdc-button  btn-white mgr-8 mgl-8 t-color-secondaryBtnText" @click="moveIssue()">
          {{ $t("1395") }}
          <!-- Declaration -->
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 문항별 피드백 공통 컴포넌트(question feedback common component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { examMixin } from "@/mixins/exam.js";
import {MDCRipple} from '@material/ripple'
export default {
  props: [
    "commonFeedback",
    "correctFeedback",
    "incorrectFeedback",
    "videoFeedback",
    "feedbackStatus",
    "correct",
    "questionId",
  ],
  data() {
    return {
      commentaryViewStatus: true,
    };
  },
  mixins: [examMixin],
  mounted() {
     this.setMaterialUi()
  },
  methods: {
    toggleCommentaryViewStatus() {
      this.commentaryViewStatus = !this.commentaryViewStatus;
    },

    strippedContent(contents) {
      let regex = /(<([^>]+)>)/gi;
      return contents.replace(regex, "");
    },

    stateQuestionButton() {
      return;
      !(this.correctFeedback && this.feedback.CORRECT) &&
        !(this.incorrectFeedback && this.feedback.INCORRECT) &&
        !(this.videoFeedback && this.feedback.SOLVE_VIDEO);
    },

    isCommon() {
      return this.commonFeedback && this.feedbackStatus.COMMON;
    },

    isCorrect() {
      return (
        this.correctFeedback && this.feedbackStatus.CORRECT && this.correct
      );
    },

    isIncorrect() {
      return (
        this.incorrectFeedback && this.feedbackStatus.INCORRECT && !this.correct
      );
    },

    isVideo() {
      return this.videoFeedback && this.feedbackStatus.SOLVE_VIDEO;
    },
    setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

        },
  },
};
</script>
